// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import load from 'load-script';
import { FacebookDeveloperId, NATUrl } from './constants';

interface InitConfig {
    appId: string,
    cookie: boolean, // enable cookies to allow the server to access
    xfbml: boolean, // parse social plugins on this page
    version: string // use version 2.1
}

interface LoginParams {
    scope: string
}

export interface AuthResponse {
    accessToken: string,
    userID: string
}

export interface LoginStatusResponse {
    authResponse?: AuthResponse;
}

declare global {
    interface Window {
        FB?: {
            init: (config: InitConfig) => void,
            login: (config: (response: void) => void, params: LoginParams) => void,
            getLoginStatus: (config: (response: LoginStatusResponse) => void)=> void,
        };
    }
}

export class Facebook {
  private static initialized = false;

  public static async initialize(): Promise<void> {
    if (!this.initialized) {
      this.initialized = true;

      await new Promise<void>((resolve, reject) => {
        // disable no unsafe call
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        load('https://connect.facebook.net/en_US/all.js', (err: Error | null) => {
          if (err) {
            reject(err);
          } else {
            resolve();
          }
        }) as unknown as void;
      });
    }
  }

  public static authorize(): void {
    const redirectUrl = window.location.origin;
    const oauthUrl = encodeURIComponent(`https://www.facebook.com/v9.0/dialog/oauth?client_id=${FacebookDeveloperId}&response_type=code&redirect_uri=${NATUrl}`);
    try {
      window.location.replace(`${NATUrl}?oauth_url=${oauthUrl}&redirect_url=${redirectUrl}/`);
    } catch {
      throw new Error('unable to connect to instagram');
    }
  }

  public static async fbLogin(scope: string): Promise<void> {
    return new Promise<void>((resolve) => {
      if (window.FB) {
        window.FB.login(() => resolve(), { scope });
      }
    });
  }

  public static async getLoginStatus(): Promise<LoginStatusResponse> {
    return new Promise<LoginStatusResponse>((resolve) => {
      if (window.FB) {
        window.FB.getLoginStatus((response) => {
          resolve(response);
        });
      }
    });
  }

  public static async login(scope = 'email'): Promise<LoginStatusResponse> {
    if (!window.FB) {
      throw new Error('Facebook SDK is not loaded');
    }

    window.FB.init({
      appId: FacebookDeveloperId,
      cookie: true,
      xfbml: true,
      version: 'v8.0',
    });

    await Facebook.fbLogin(scope);

    return Facebook.getLoginStatus();
  }
}
